import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function ProtectedRoute({ children, allowRoles }) {
  const { agent, loading } = useAuth();
  if (loading) return null;
  if (!agent) return <Navigate to="/login" replace />;

  // Receptionist solo puede acceder a /backdesk/extensions
  if (agent.role === 'receptionist') {
    const path = window.location.pathname;
    if (!path.startsWith('/backdesk/extensions')) {
      return <Navigate to="/backdesk/extensions" replace />;
    }
  }

  // Restricción por roles específicos si se indica
  if (allowRoles && !allowRoles.includes(agent.role)) {
    return <Navigate to="/backdesk" replace />;
  }

  return children;
}
